import BaseSliderBlock from "./BaseSliderBlock";
import Swiper, {Autoplay, Navigation, Pagination} from "swiper";

export default class Testimonials extends BaseSliderBlock {

	init() {

		const sliderEl = this.block.querySelector(".swiper");

		if (sliderEl instanceof HTMLElement) {
			new Swiper(sliderEl, {
				loop: true,
				spaceBetween: 40,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				navigation: this.getDefaultNavigation(),
				pagination: this.getDefaultPagination(),
				modules: [Autoplay, Navigation, Pagination]
			});
		}

	}
}
